// One request in flight per store and key: callers started while it runs get
// its promise. Finished results are not kept: the next call requests again,
// and the data lives in the store as before.
const requestsByStore = new WeakMap();

const shareInFlight = (store, key, start) => {
  let requests = requestsByStore.get(store);
  if (!requests) {
    requests = new Map();
    requestsByStore.set(store, requests);
  }
  if (requests.has(key)) return requests.get(key);
  const promise = Promise.resolve(start()).finally(() => {
    if (requests.get(key) === promise) requests.delete(key);
  });
  requests.set(key, promise);
  return promise;
};

export default shareInFlight;
